import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Theme, useTheme } from "@mui/material/styles";

type SelectProps = {
  variant: "outlined" | "standard" | "filled";
  value: any;
  label: any;
  onChange: (value: any) => void;
  menulist: any;
  menuvalue: any;
  name?: string;
  className?: string;
  fullWidth?: true | false;
  multiple?: true | false;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

export default function MultiSelectComponent(props: SelectProps) {
  const theme = useTheme();
  return (
    props.menulist && (
      <Select
        value={props.value}
        label={props.label}
        onChange={(event) => props.onChange(event.target)}
        className={props.className}
        fullWidth={props.fullWidth}
        multiple
        variant={props.variant}
        id={"select"}
        name={props.name}
        MenuProps={MenuProps}
      >
        {props.menulist.map((item: any) => (
          <MenuItem
            key={item.p_id}
            value={item.p_id}
            style={getStyles(item, props.menulist, theme)}
          >
            {item[props.menuvalue]}
          </MenuItem>
        ))}
      </Select>
    )
  );
}
